/**
 * Urine Test Formula
 * ตรวจสอบผลการตรวจปัสสาวะ
 *
 * @param {Object} urineData - ข้อมูลการตรวจปัสสาวะ
 * @returns {Object} { status, color, description }
 */

const UrineTestFormula = (urineData) => {
  if (!urineData || typeof urineData !== 'object') {
    return {
      status: 'ไม่มีข้อมูล',
      color: 'gray',
      description: 'ไม่พบข้อมูลการตรวจปัสสาวะ'
    };
  }

  // ตรวจสอบค่าที่ผิดปกติ
  const abnormalFindings = [];

  // pH (ค่าปกติ: 4.6-8.0)
  if (urineData.ph) {
    const phValue = parseFloat(urineData.ph);
    if (!isNaN(phValue) && (phValue < 4.6 || phValue > 8.0)) {
      abnormalFindings.push('pH');
    }
  }

  // Specific Gravity (ค่าปกติ: 1.005-1.030)
  if (urineData.specificGravity) {
    const sg = parseFloat(urineData.specificGravity);
    if (!isNaN(sg) && (sg < 1.005 || sg > 1.030)) {
      abnormalFindings.push('Specific Gravity');
    }
  }

  // Protein (ค่าปกติ: Negative หรือ Trace)
  if (urineData.protein) {
    const protein = urineData.protein.toString().toLowerCase();
    if (protein !== 'negative' && protein !== 'trace' && protein !== '-') {
      abnormalFindings.push('Protein');
    }
  }

  // Glucose (ค่าปกติ: Negative)
  if (urineData.glucose) {
    const glucose = urineData.glucose.toString().toLowerCase();
    if (glucose !== 'negative' && glucose !== '-') {
      abnormalFindings.push('Glucose');
    }
  }

  // Ketones (ค่าปกติ: Negative)
  if (urineData.ketones) {
    const ketones = urineData.ketones.toString().toLowerCase();
    if (ketones !== 'negative' && ketones !== '-') {
      abnormalFindings.push('Ketones');
    }
  }

  // Blood (ค่าปกติ: Negative)
  if (urineData.blood) {
    const blood = urineData.blood.toString().toLowerCase();
    if (blood !== 'negative' && blood !== '-') {
      abnormalFindings.push('Blood');
    }
  }

  // Bilirubin (ค่าปกติ: Negative)
  if (urineData.bilirubin) {
    const bilirubin = urineData.bilirubin.toString().toLowerCase();
    if (bilirubin !== 'negative' && bilirubin !== '-') {
      abnormalFindings.push('Bilirubin');
    }
  }

  // Urobilinogen (ค่าปกติ: 0.1-1.0 mg/dL หรือ Normal)
  if (urineData.urobilinogen) {
    const urobilinogen = urineData.urobilinogen.toString().toLowerCase();
    if (urobilinogen !== 'normal' && urobilinogen !== '-') {
      const value = parseFloat(urobilinogen);
      if (!isNaN(value) && (value < 0.1 || value > 1.0)) {
        abnormalFindings.push('Urobilinogen');
      }
    }
  }

  // Leukocytes (ค่าปกติ: Negative)
  if (urineData.leukocytes) {
    const leukocytes = urineData.leukocytes.toString().toLowerCase();
    if (leukocytes !== 'negative' && leukocytes !== '-') {
      abnormalFindings.push('Leukocytes');
    }
  }

  // Nitrite (ค่าปกติ: Negative)
  if (urineData.nitrite) {
    const nitrite = urineData.nitrite.toString().toLowerCase();
    if (nitrite !== 'negative' && nitrite !== '-') {
      abnormalFindings.push('Nitrite');
    }
  }

  // Red Blood Cells (ค่าปกติ: 0-3 cells/HPF)
  if (urineData.redBloodCells) {
    const rbc = parseFloat(urineData.redBloodCells);
    if (!isNaN(rbc) && rbc > 3) {
      abnormalFindings.push('Red Blood Cells');
    }
  }

  // White Blood Cells (ค่าปกติ: 0-5 cells/HPF)
  if (urineData.whiteBloodCells) {
    const wbc = parseFloat(urineData.whiteBloodCells);
    if (!isNaN(wbc) && wbc > 5) {
      abnormalFindings.push('White Blood Cells');
    }
  }

  // กำหนดสถานะและสีตามจำนวนค่าผิดปกติ
  if (abnormalFindings.length === 0) {
    return {
      status: 'ปกติ',
      color: 'green',
      description: 'ผลการตรวจปัสสาวะอยู่ในเกณฑ์ปกติ',
      abnormalFindings: []
    };
  } else {
    return {
      status: 'ผิดปกติ',
      color: 'red',
      description: `พบค่าผิดปกติ: ${abnormalFindings.join(', ')}`,
      abnormalFindings: abnormalFindings
    };
  }
};

export default UrineTestFormula;
